export const EMPTY_FORM = {
  name: '', mobile: '', email: '', address_type: 'Home', address: '',
  pincode: '', city: '', state: '', latitude: '', longitude: '', is_default: false,
  gstin: '',
};

export const ADDRESS_TYPES = ['Home', 'Work', 'Other'];
export const REQUIRED = ['name', 'mobile', 'email', 'address', 'pincode', 'city', 'state'];
export const SERVICEABLE_PINCODES = ['411028', '411023'];
export const MAX_ADDRESS_LENGTH = 100;

export const validateField = (name, value) => {
  switch (name) {
    case 'name':
      if (!value?.trim()) return 'Name is required';
      if (value.trim().length < 2) return 'Min 2 characters';
      return '';
    case 'email':
      if (!value?.trim()) return 'Email is required';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim())) return 'Enter valid email';
      return '';
    case 'mobile':
      if (!value?.trim()) return 'Mobile number is required';
      if (!/^[6-9]\d{9}$/.test(value.trim())) return 'Enter a valid 10-digit mobile number';
      return '';
    case 'address':
      if (!value?.trim()) return 'Address is required';
      if (value.trim().length < 10) return 'Enter a complete address';
      if (value.trim().length > MAX_ADDRESS_LENGTH) return `Address must be ${MAX_ADDRESS_LENGTH} characters or less`;
      return '';
    case 'city':
      if (!value?.trim()) return 'City is required';
      if (!/^[a-zA-Z\s]+$/.test(value.trim())) return 'Letters only';
      return '';
    case 'state':
      if (!value?.trim()) return 'State is required';
      if (!/^[a-zA-Z\s]+$/.test(value.trim())) return 'Letters only';
      return '';
    case 'pincode':
      if (!value?.trim()) return 'PIN code is required';
      if (/[^0-9]/.test(value.trim())) return 'Numbers only';
      if (value.trim().length !== 6) return 'Must be 6 digits';
      return '';
    case 'latitude':
      if (String(value ?? '').trim() && isNaN(parseFloat(value))) return 'Enter a valid number';
      return '';
    case 'longitude':
      if (String(value ?? '').trim() && isNaN(parseFloat(value))) return 'Enter a valid number';
      return '';
    default: return '';
  }
};
